import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/chatBg.png'
import _imports_1 from '@/assets/images/icon2.png'
import _imports_2 from '@/assets/images/icon4.png'


const _hoisted_1 = { class: "orderChat" }
const _hoisted_2 = {
  key: 0,
  class: "chatBg"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "chatBox" }
const _hoisted_5 = { class: "info flexBothEnds" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = { class: "avatar" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "fontGrey" }
const _hoisted_10 = {
  key: 0,
  class: "right"
}
const _hoisted_11 = {
  key: 0,
  src: _imports_1
}
const _hoisted_12 = { class: "fontGrey" }
const _hoisted_13 = { class: "fontGrey" }
const _hoisted_14 = { class: "fontGrey" }
const _hoisted_15 = { class: "fontGrey" }
const _hoisted_16 = {
  id: "chatList",
  class: "chatList scroll"
}
const _hoisted_17 = { class: "item itemTime" }
const _hoisted_18 = { class: "itemD avatar" }
const _hoisted_19 = { class: "itemD content" }
const _hoisted_20 = { class: "itemD avatar" }
const _hoisted_21 = { class: "itemD avatar" }
const _hoisted_22 = { class: "itemD avatar" }
const _hoisted_23 = {
  key: 2,
  class: "item itemTip"
}
const _hoisted_24 = { class: "itemD" }
const _hoisted_25 = { class: "inputSend flexBothEnds" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("picture", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showStatus == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_icon, { class: "is-loading" }, {
            default: _withCtx(() => [
              _createVNode(_component_loading)
            ]),
            _: 1
          }),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "top",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoMerchantInfo(_ctx.heUserInfo)))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.heUserInfo.nickName.substring(0, 1)), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(_ctx.heUserInfo.nickName), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.langObj.l0130 + "：" + _ctx.formatDateYMD(_ctx.heUserInfo.createTime)), 1)
            ])
          ]),
          (_ctx.heUserInfo.levelId > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_ctx.merchant == 1)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.merchant == 0 ? _ctx.langObj.l0386 : _ctx.langObj.l0128), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_row, { class: "infoData" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              class: "flexBothEnds",
              span: 10
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.langObj.l0153), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.otcData.success + _ctx.langObj.l0341), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "flexBothEnds",
              offset: 4,
              span: 10
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.langObj.l0154), 1),
                _createElementVNode("span", null, _toDisplayString((_ctx.otcData.successRatio > 0 ? _ctx.otcData.successRatio * 100 : 0).toFixed(0)) + "%", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "flexBothEnds",
              span: 10
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.langObj.l0155), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.otcData.successByMonth + _ctx.langObj.l0341), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "flexBothEnds",
              offset: 4,
              span: 10
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.langObj.l0156), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.getCountdown(_ctx.otcData.avgPermitTime)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serializeData(_ctx.chatObj[_ctx.orderId]), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "items",
            key: index
          }, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(item.time), 1),
            (item.type == 'text')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(['item', 'itemText', item.isMy ? 'classMy' : 'classHe'])
                }, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.heUserInfo.nickName.substring(0, 1)), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(item.message), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.userInfo.nickName.substring(0, 1)), 1)
                ], 2))
              : (item.type == 'img')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(['item', 'itemImages', item.isMy ? 'classMy' : 'classHe'])
                  }, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.heUserInfo.nickName.substring(0, 1)), 1),
                    _createVNode(_component_el_image, {
                      "hide-on-click-modal": "",
                      fit: "scale-down",
                      src: item.message,
                      "preview-src-list": [item.message]
                    }, null, 8, ["src", "preview-src-list"]),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.userInfo.nickName.substring(0, 1)), 1)
                  ], 2))
                : (item.type == 'system')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(item.message), 1)
                    ]))
                  : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_el_upload, {
          class: "avatar-uploader",
          action: _ctx.host + '/im/file/upload',
          headers: _ctx.imgHeader,
          "show-file-list": false,
          "on-success": _ctx.handleAvatarSuccess,
          "on-error": _ctx.handleAvatarError
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["action", "headers", "on-success", "on-error"]),
        _createVNode(_component_el_input, {
          size: "small",
          modelValue: _ctx.sendVal,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sendVal) = $event)),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onSendVal()), ["enter"])),
          placeholder: _ctx.langObj.l0366
        }, null, 8, ["modelValue", "placeholder"]),
        _createElementVNode("img", {
          src: _imports_2,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSendVal && _ctx.onSendVal(...args)))
        })
      ])
    ], 512), [
      [_vShow, _ctx.showStatus == 2]
    ])
  ]))
}